<template lang="pug">
  .modal.modal--md.notification-event
    button.modal__close(
      @click="$emit('close')"
    )
    img(
      src="@/assets/images/icons/pike.svg"
    )
    h2.modal__title {{ modalData.orderingModalData.title }}
    p.modal__text
      b {{translation.service_words.where}}:
      span  {{modalData.orderingModalData.address}}
      br
      b {{translation.service_words.when}}:
      span  {{modalData.orderingModalData.date_time}}
    p.modal__text {{ modalData.info }}
    .modal__button
      button.button.button_paint-main(
        @click="onButtonClick"
      )
        .button__text {{ modalData.buttonText || 'Спасибо' }}
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "notification-event",
  props: ["modalData"],
  computed: {
    ...mapState(["translation"]),
  },
  methods: {
    ...mapActions(["confirmRegistration", "getUser"]),
    onButtonClick() {
      this.$emit(
        "changeModalMode",
        "ordering",
        this.modalData.orderingModalData
      );
    },
  },
};
</script>
